import React, { useCallback, useMemo } from "react";
import styles from "./index.module.less";
import { FocusSDK } from "@/utils";
import IconFont from "@/components/icon";
import { convertUIDToString } from "@jd/focus-desktop-comps/lib/es/utils";
import { getUserEbookDetailList } from "@/api/ebook";
import { Employee } from "@/types/chat";
/**
 * AI推荐问题
 */
function AiRecommendCard(props: any) {
  const { message } = props;
  const dataInfo = useMemo(() => {
    return (message?.data || []).map((item: any) => {
      const { sharecard = {} } = item;
      return {
        ...sharecard,
        id: convertUIDToString(sharecard),
        name: sharecard?.realName,
        avatar: sharecard?.avatar,
        checked: true,
        userId: sharecard?.pin || sharecard?.userId,
        app: sharecard?.app || sharecard?.appId,
        appId: sharecard?.app || sharecard?.appId,
        teamId: sharecard?.teamId,
        visible: true
      };
    });
  }, [message?.data]);

  // 扩展数据
  const extData = useMemo(() => {
    if (!message?.ext) {
      return {};
    }
    try {
      return typeof message?.ext === "string" ? JSON.parse(message?.ext) : message?.ext;
    } catch (e) {
      return {};
    }
  }, [message?.ext]);

  // 搜索
  const handleSearch = useCallback(() => {
    const { keyword = "" } = extData;
    FocusSDK.sendToMain("ai:global:add_friend", {
      keyword
    });
  }, [extData]);

  const onRecommendClick = useCallback(
    async (tip: any) => {
      if (tip?.action === "add_friend") {
        handleSearch();
      }
      if (tip?.action === "create_group") {
        const users = await getUserEbookDetailList(dataInfo);
        const userList = (users as any[]).map((user) => {
          let fields: any = {};
          (user?.fields || []).forEach((item: any) => {
            fields[item.key] = item.val;
          });
          return {
            pin: user.userId,
            app: user.appId,
            ...user,
            ...fields
          };
        });
        FocusSDK.sendToMain("ai:global:create_group", userList);
      } else {
        FocusSDK.sendToMain(`ai:global:${tip.action}`, "");
      }
    },
    [dataInfo, handleSearch]
  );

  const searchRecommendContent = useMemo(() => {
    if (!message?.recommendTips?.length) {
      return <div />;
    }
    const recommendTips = message?.recommendTips || [];
    return (
      <div className={styles["search-recommend-wrap"]}>
        <span className={styles["recommend-title"]}>您可能想问</span>
        {recommendTips.map((tip: any, idx: number) => {
          return (
            <div
              key={`tip_${message.id}_${idx}`}
              className={styles["text-wrap"]}
              onClick={() => onRecommendClick(tip)}
            >
              <span className={`${styles["text"]} ellipsis`}>{tip.srLabel}</span>
              <div className={styles["btn-text"]}>
                <IconFont
                  type={`icon${tip.iconfont}` || "iconicon_search"}
                  className={styles["icon"]}
                />
                <span>{tip.actionLabel}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }, [message?.id, message?.recommendTips]);

  return searchRecommendContent;
}

export default AiRecommendCard;
